import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import {
    failurelistQuestionMapping,
    successlistQuestionMapping,
} from "./QuestionMappingSlice";

// Question mapping API - GET request with query parameters
const QuestionMappingApi = (action: PayloadAction<any>) => {
    const params = action.payload;
    return api.get("/api/question/for-mapping", { params });
};

export function* QuestionMappingCall(action: PayloadAction<any>) {
    try {
        const response: AxiosResponse = yield call(QuestionMappingApi, action);
        yield put(successlistQuestionMapping(response.data));
    } catch (error) {
        yield put(failurelistQuestionMapping(error));
    }
}
